import React from 'react';
import { StrategicMap } from '../components/StrategicMap';
import { Building2, Clock, ShieldCheck, MapPin } from 'lucide-react';
export function Locations() {
  return <div className="bg-white" data-id="element-451">
      <div className="bg-federal-blue py-16 text-white" data-id="element-452">
        <div className="max-w-7xl mx-auto px-4 md:px-8" data-id="element-453">
          <h1 className="text-4xl md:text-5xl font-black mb-4" data-id="element-454">
            Strategic Locations
          </h1>
          <p className="text-white/70 max-w-2xl text-lg" data-id="element-455">
            Positioned for rapid response and high-touch support across the
            Mid-Atlantic and Southeast.
          </p>
        </div>
      </div>

      <StrategicMap data-id="element-456" />

      <section className="py-16 bg-white" data-id="element-457">
        <div className="max-w-7xl mx-auto px-4 md:px-8" data-id="element-458">
          <div className="grid md:grid-cols-2 gap-12" data-id="element-459">
            <div className="p-8 border border-slate-200 rounded-sm bg-slate-50" data-id="element-460">
              <div className="flex items-center gap-3 mb-6" data-id="element-461">
                <MapPin className="w-6 h-6 text-federal-blue" data-id="element-462" />
                <h3 className="text-2xl font-black text-federal-blue uppercase" data-id="element-463">
                  Charlotte Hub
                </h3>
              </div>
              <ul className="space-y-4 text-tech-slate" data-id="element-464">
                <li className="flex items-center gap-3" data-id="element-465">
                  <Building2 className="w-4 h-4 text-federal-blue opacity-50" data-id="element-466" />{' '}
                  Regional Headquarters & Logistics
                </li>
                <li className="flex items-center gap-3" data-id="element-467">
                  <Clock className="w-4 h-4 text-federal-blue opacity-50" data-id="element-468" />{' '}
                  24/7 Technical Support Center
                </li>
                <li className="flex items-center gap-3" data-id="element-469">
                  <ShieldCheck className="w-4 h-4 text-federal-blue opacity-50" data-id="element-470" />{' '}
                  Secure Hardware Staging Facility
                </li>
              </ul>
            </div>
            <div className="p-8 border border-slate-200 rounded-sm bg-slate-50" data-id="element-471">
              <div className="flex items-center gap-3 mb-6" data-id="element-472">
                <MapPin className="w-6 h-6 text-federal-blue" data-id="element-473" />
                <h3 className="text-2xl font-black text-federal-blue uppercase" data-id="element-474">
                  Baltimore Hub
                </h3>
              </div>
              <ul className="space-y-4 text-tech-slate" data-id="element-475">
                <li className="flex items-center gap-3" data-id="element-476">
                  <Building2 className="w-4 h-4 text-federal-blue opacity-50" data-id="element-477" />{' '}
                  Federal Agency Liaison Office
                </li>
                <li className="flex items-center gap-3" data-id="element-478">
                  <Clock className="w-4 h-4 text-federal-blue opacity-50" data-id="element-479" />{' '}
                  Rapid Response Field Engineering
                </li>
                <li className="flex items-center gap-3" data-id="element-480">
                  <ShieldCheck className="w-4 h-4 text-federal-blue opacity-50" data-id="element-481" />{' '}
                  Compliance & Security Audit Lab
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </div>;
}